import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-fin-flujoPEmb',
    standalone: false,
    templateUrl: './fin-flujoPEmb.component.html',
    styleUrl: './fin-flujoPEmb.component.scss',
})

export class FinFlujoPEmbComponent implements OnInit {
    sessionId: string = '';

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {

    }

    getLocalStorage(): number {
        return Number(localStorage.getItem('session_id'))
    }

    ngOnInit(): void {
        this.sessionId = this.getLocalStorage().toString();
    }

    volverInicio(): void {
        this.router.navigate(['./']);
    }
}
